import { render, staticRenderFns } from "./PublishManager.vue?vue&type=template&id=957c10a2&scoped=true"
import script from "./PublishManager.vue?vue&type=script&lang=js"
export * from "./PublishManager.vue?vue&type=script&lang=js"
import style0 from "./PublishManager.vue?vue&type=style&index=0&id=957c10a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957c10a2",
  null
  
)

export default component.exports